
import GallerysBgColorsData from "../../js/gallerysBgColorsData";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import Modal from "react-modal";
import {
  Animatespin,
  Footer,
  Navbar,
  GalleryCom,
} from "../../components/index";
import Functions from "./index.function";
const MissionSheDetails = () => {
  const {
    isLoading,
    missionSHE,
    openGallery,
    isOpen,
    closeGallery,
    selectedIndex,
    galleryImages,
    localimgpath
  } = Functions();
  return (
    <div className="bg-primary">
      <div className="relative">
        <div className="absolute top-0 left-0 w-full z-10">
          <Navbar />
          {isLoading ? (
            <Animatespin />
          ) : (
            <div className="flex justify-start items-center lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:h-40 sm:h-80 lg:h-[88vh]">
              <div>
                <div>
                  <h1 className="uppercase text-secondary font-unboundedSemiBold lg:text-5xl lg:leading-tight">
                    {missionSHE.heading}
                  </h1>
                </div>
                <div>
                  <p className="text-secondary font-onestMedium lg:text-xl">
                    {missionSHE?.sub_heading}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          <img
            className=" w-full xs:h-60 sm:h-96 lg:h-screen"
            src={`${localimgpath?.mission_sheBanner}/${missionSHE?.banner}`}
            alt={missionSHE?.real_name}
          />
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-black/90 to-transparent " />
        </div>
      </div>
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto xs:pt-5 sm:py-16 lg:pt-14 text-white">
        <div className="">
          <h2 className="text-secondary font-unboundedMedium lg:text-2xl xs:mb-1.5 sm:mb-2 lg:mb-3.5">
            Description
          </h2>
          <p
            className="text-secondary font-onestLight xs:mb-1 xs:text-xs sm:text-xs xl:mb-4 lg:mb-2 sm:mb-2 xl:text-base lg:text-sm "
            dangerouslySetInnerHTML={{ __html: missionSHE?.description }}
          />
        </div>
        {/* <div className=" text-white py-10">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-left">
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Genre/Duration</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">Animation | 01 hr 30 min</span>
                        </div>
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Rating</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">U</span>
                        </div>
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Language</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">Urdu</span>
                        </div>
                        <div>
                            <p className="font-onestMedium xs:text:sm sm:text-lg">Director</p>
                            <span className="xs:text-xs sm:text-sm font-onestLight">Uzair Zaheer Khan</span>
                        </div>
                    </div>
                </div> */}

        {/* <div>
                    {missionSHE?.galleries?.length === 0 ? (
                        <></>
                    ) : (
                        <div className="lg:py-3 xs:pb-2">
                            <h2 className="text-secondary font-onestMedium lg:text-2xl">Gallery</h2>
                            <div className="lg:pt-10 sm:pt-6 xs:py-5 xs:pb-3 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2.5">
                                {missionSHE?.galleries?.map((Item, index) => (
                                    <div key={`${index}`} className="w-full xs:h-[140px] sm:h-[150px] lg:h-[200px] xl:h-[250px]">
                                        <img src={`${localimgpath?.mission_sheGallery}/${Item?.image}`} className="w-full h-full" alt="Gallery" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div> */}
        <div>
          {missionSHE?.galleries?.length > 0 && (
            <div className="lg:pt-3">
              <h2 className="text-secondary font-unboundedMedium lg:text-2xl">
                Gallery
              </h2>
              <div className="flex flex-wrap xs:gap-3 lg:gap-4 xs:pt-5 xs:justify-center sm:justify-center sm:gap-4 sm:pt-6 lg:justify-center">
                {Array.isArray(missionSHE?.galleries) &&
                missionSHE?.galleries?.length > 0 ? (
                  missionSHE?.galleries?.map((galleryItem, index) => (
                    <div
                      key={index}
                      onClick={() => openGallery(index)}
                      className="cursor-pointer"
                    >
                      <GalleryCom
                        latestNewsthubmail={`${localimgpath?.mission_sheGallery}/${galleryItem?.image}`}
                        alt={galleryItem?.galleryable_type}
                        layout={
                          "xs:w-32 xs:h-32 sm:w-40 sm:h-40 lg:w-56 lg:h-56 rounded-full"
                        }
                        Img={"w-[95%] h-[95%] rounded-full"}
                        bgcolor={
                          GallerysBgColorsData[
                            index % GallerysBgColorsData?.length
                          ]?.eventsGallerycolor
                        }
                      />
                    </div>
                  ))
                ) : (
                  <p className="text-secondary">No gallery data available</p>
                )}
              </div>
            </div>
          )}
          <Modal
            isOpen={isOpen}
            onRequestClose={closeGallery}
            contentLabel="Image Gallery Modal"
            className="w-full mx-0 sm:mx-auto p-4 sm:p-6 bg-primary rounded-lg shadow-xl overflow-y-auto"
            overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
          >
            <button
              onClick={closeGallery}
              className="absolute top-2 right-2 text-white text-xl z-10"
            >
              ✕
            </button>

            <ImageGallery
              items={galleryImages}
              startIndex={selectedIndex}
              showPlayButton={false}
              showFullscreenButton={true}
              showThumbnails={true}
              showIndex={true}
            />
          </Modal>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default MissionSheDetails;
